import React from "react";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import { Breadcrumb, Col } from "react-bootstrap";

import { Tabs, Tab } from "react-bootstrap";
import GeneralSettings from "./GeneralSettings";
import WebsiteSettingsPage from "./WebsiteSettingsPage";
import AppSettingsPage from "./AppSettingsPage";
import SystemSettings from "./SystemSettings";
import FinancialSettingsPage from "./FinancialSettingsPage";
import OtherSettingsPage from "./OtherSettingsPage";
import { CiSettings } from "react-icons/ci";
import {
  FiSettings,
  FiGlobe,
  FiSmartphone,
  FiCpu,
  FiDollarSign,
  FiBox
} from "react-icons/fi";
const SettingsPage = () => {
  return (
<div  style={{ padding: "15px", background: "#f8f9fa",  }} >
    <div   >
      
   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Settings</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                     General Settings

                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Profile Settings</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>
               
       
    </div>
      <div className="settings-page mx-3">
    
<Tabs defaultActiveKey="general" className="settings-tabs mb-3">

  <Tab
    eventKey="general"
    title={<span><FiSettings className="me-2 tab-icon" />General Settings</span>}
  >
    <GeneralSettings />
  </Tab>

  <Tab
    eventKey="website"
    title={<span><FiGlobe className="me-2 tab-icon" />Website Settings</span>}
  >
    <WebsiteSettingsPage />
  </Tab>

  <Tab
    eventKey="app"
    title={<span><FiSmartphone className="me-2 tab-icon" />App Settings</span>}
  >
    <AppSettingsPage />
  </Tab>

  <Tab
    eventKey="system"
    title={<span><FiCpu className="me-2 tab-icon" />System Settings</span>}
  >
    <SystemSettings />
  </Tab>

  <Tab
    eventKey="financial"
    title={<span><FiDollarSign className="me-2 tab-icon" />Financial Settings</span>}
  >
    <FinancialSettingsPage />
  </Tab>

  <Tab
    eventKey="other"
    title={<span><FiBox className="me-2 tab-icon" />Other Settings</span>}
  >
    <OtherSettingsPage />
  </Tab>

</Tabs>
      <style>
        {`/* Tabs */
.settings-tabs .nav-link {
  color: #374151;
  font-weight: 500;
}

.settings-tabs .nav-link.active {
  background: #f97316;
  color: #fff !important;
  border-radius: 6px;
}

/* Sidebar */
.settings-sidebar {
  padding: 15px;
  border-radius: 10px;
}

.sidebar-item {
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
  color: #374151;
}

.sidebar-item.active {
  background: #fff7ed;
  color: #f97316;
}

/* Card */
.settings-card {
  padding: 20px;
  border-radius: 10px;
}

/* Upload */
.upload-box {
  background: #f9fafb;
  padding: 15px;
  border-radius: 8px;
}

.upload-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #e5e7eb;
}

/* Orange button */
.btn-orange {
  background: #f97316;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #ea580c;
}

/* Responsive */
@media (max-width: 768px) {
  .settings-tabs .nav {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .settings-sidebar {
    margin-bottom: 15px;
  }
}
  /* Tabs container */
.settings-tabs .nav {
  display: flex;
  gap: 8px;
  border-bottom: none;
}

/* Tab button */
.settings-tabs .nav-link {
  display: flex;
  align-items: center;
  gap: 6px;

  padding: 10px 14px;
  border-radius: 6px;
  border: none;

  font-size: 14px;
  font-weight: 500;
  color: #374151;

  background: transparent;
  transition: all 0.2s ease;
}

/* Icon */
.tab-icon {
  font-size: 16px;
}

/* Active tab */
.settings-tabs .nav-link.active {
  background: #f97316;
  color: #fff !important;
}

/* Hover */
.settings-tabs .nav-link:hover {
  background: #f3f4f6;
}

/* Remove default bootstrap border */
.settings-tabs .nav-tabs {
  border-bottom: none;
}
          
          `}
      </style>
    </div>
</div>
  );
};

export default SettingsPage;
